import companyLogo from '../Images/online-adda-logo.png';
import PageCard from '../Components/PageCard';
import { useLayoutEffect } from 'react';
function Jewellery(props)
{
    

    return (
        <div className="w-full h-fit bg-violet-100 md:pt-10 pt-5 pb-10 overflow-x-hidden">

            <div className="container  md:container max-w-[95%] md:max-w-[90%] mx-auto ">

            <div className=' w-fit flex flex-row mx-auto bg-[#35185A]  select-none  justify-center items-center'>
                    <img src={companyLogo} className='md:w-[250px]  w-[200px] select-none  ' />
                    <span className='font-bold md:text-6xl text-2xl md:mt-3 mt-1 -ml-2 text-center pr-5 text-white'>Jewellery</span>
                </div>

                <div className='w-full grid grid-cols-2 grid-rows-2 md:mt-10 mt-5 md:gap-10 gap-3'>
                    <PageCard Product={props.Products[0]}/>
                    <PageCard Product={props.Products[1]}/>
                    <PageCard Product={props.Products[2]}/>
                    <PageCard Product={props.Products[3]}/>

                </div>

            </div>


        </div>
    )
}

export default Jewellery;